import _ from 'underscore';
import { CWBaseModel } from 'src/core/models/cwBase.model';
import { CWSTR } from 'src/utils';
import { i18n } from 'src/i18n';


/**
 * Model for accept, reject or delete
 */
export class CWGererevtgenGestion extends CWBaseModel {

  public action: string;

  defaults(): { [key: string]: any } {
    return {
      "commentaire": ""
    }
  }

  constructor(attributes?: { [key: string]: any }, options?: { [key: string]: any }) {
    if (!options && !_.isEmpty(attributes)) {
      options = attributes;
    }
    options = options || {};
    super(attributes, options);
    this.url = (): string => {
      const id = this.isNew() === true ? "" : encodeURIComponent(this.id);

      return Configuration.restRoot + "/rest/composant/evtgen/" + this.action + "/" + id;
    };
  }

  validate(attrs: { [key: string]: any }): { [key: string]: any } {
    if (this.action === "refuser") {
      const errors: { [key: string]: any } = {};

      if (CWSTR.isBlank(attrs.commentaire)) {
        errors.commentaire = i18n.t('common:required', { "0": i18n.t('common:gererevtgen.comment') });
      }
      if (!_.isEmpty(errors)) {
        const errorMap = {
          errorValidation: CWSTR.formatMessage(errors),
          errors: errors
        };

        return errorMap;
      }
    }
    return null;
  }

  parse(response: { [key: string]: any }): { [key: string]: any } {
    if (CWSTR.isBlank(response.id) && !CWSTR.isBlank(response.code)) {
      response.id = response.code;
    }
    return response;
  }
}